export default __webpack_public_path__ + "16417dfd659297ae6b047187b2e01e54.svg";